





















import { Component, Vue, Prop } from 'vue-property-decorator';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ALL_MUNICIPALITIES } from '@/queries/Municipality';
import { GQL_deleteMunicipalitySelection_deleteMunicipalitySelection_municipalitySelection } from '@/queries/__generated__/deleteMunicipalitySelection';
import { GQL_municipalitySelections_currentUnit_municipalitySelections, GQL_municipalitySelections } from '@/queries/__generated__/municipalitySelections';
import { GQL_municipalities } from '../../queries/__generated__/municipalities';
import gql from 'graphql-tag';
import { MUNICIPALITY_SELECTIONS } from './municipalitySelections';

const DELETE_MUNICIPALITY_SELECTION = gql`
  mutation deleteMunicipalitySelection($id: ID!) {
    deleteMunicipalitySelection(input: { id: $id }) {
      municipalitySelection {
        id
        municipality {
          id
        }
      }
    }
  }
`;

interface IDeleteMunicipalityResponse {
  data: {
    deleteMunicipalitySelection: {
      municipalitySelection: GQL_deleteMunicipalitySelection_deleteMunicipalitySelection_municipalitySelection;
    };
  };
}

@Component
export default class MunicipalitySelectionDeleteButton extends Vue {
  @Prop() private municipalitySelection!: GQL_municipalitySelections_currentUnit_municipalitySelections;

  private DELETE_MUNICIPALITY_SELECTION = DELETE_MUNICIPALITY_SELECTION;
  private MUNICIPALITY_SELECTIONS = MUNICIPALITY_SELECTIONS;

  private removeFromCache(
    store: InMemoryCache,
    { data: { deleteMunicipalitySelection: { municipalitySelection } } }: IDeleteMunicipalityResponse,
  ) {
    const data = (store.readQuery({ query: MUNICIPALITY_SELECTIONS }) as GQL_municipalitySelections);
    data.currentUnit.municipalitySelections = data.currentUnit.municipalitySelections.filter(c => c.id !== municipalitySelection.id);
    store.writeQuery({ query: MUNICIPALITY_SELECTIONS, data });

    try {
      const data = (store.readQuery({ query: ALL_MUNICIPALITIES }) as GQL_municipalities);
      data.currentUnit.municipalities = data.currentUnit.municipalities.filter(m => m.id !== municipalitySelection.municipality.id);
      store.writeQuery({ query: ALL_MUNICIPALITIES, data });
    } catch (e) {}
  }

  private confirmDelete(confirmMutation: () => {}) {
    this.$sPopup.confirm(``, {
      title: this.$t('PopupTitle.confirmDelete'),
      message: this.$t('PopupBody.confirmDelete', { thing: this.municipalitySelection.municipality.name }),
      onConfirm: confirmMutation,
    });
  }
}
